import AdmissionPage from "../components/admission/admission";


export default function AdmissionView(){
    
    return (
        <AdmissionPage />
    )
}